import React from 'react';

interface AvisoDadosDesatualizadosProps {
  /** Há uma falha a mostrar (a última busca deu erro). */
  erro: boolean;
  /** O widget ainda mostra números de uma busca anterior (os dados NÃO foram apagados). */
  comDadosAnteriores: boolean;
  onTentarDeNovo: () => void;
  /** Texto do erro (ex.: o código do erro 500), mostrado em letra menor. */
  detalhe?: string | null;
  carregando?: boolean;
}

// Aviso padrão de todos os widgets do Dashboard quando a última busca falhou. Com números antigos na tela diz que eles estão
// DESATUALIZADOS (não correspondem aos filtros atuais); sem números, diz que não foi possível carregar. Sempre com "Tentar de novo".
const AvisoDadosDesatualizados: React.FC<AvisoDadosDesatualizadosProps> = ({ erro, comDadosAnteriores, onTentarDeNovo, detalhe, carregando }) => {
  if (!erro) return null;
  return (
    <div role="alert" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px 12px', margin: '0 0 8px', padding: '6px 12px', background: '#fff7e6', border: '1px solid #ffd9a0', borderRadius: '8px', fontSize: '0.8rem', color: '#7a5a00' }}>
      <span>
        <strong>{comDadosAnteriores ? 'Dados desatualizados: falha ao aplicar o último filtro.' : 'Não foi possível carregar este bloco.'}</strong>
        {detalhe && <span style={{ marginLeft: 6, fontSize: '0.72rem', color: '#9a7a20' }}>{detalhe}</span>}
      </span>
      <button
        type="button"
        onClick={onTentarDeNovo}
        disabled={carregando}
        style={{ border: '1px solid #e0a040', background: '#fff', color: '#7a5a00', borderRadius: '14px', padding: '2px 12px', cursor: carregando ? 'default' : 'pointer', fontSize: '0.78rem', fontWeight: 600, opacity: carregando ? 0.6 : 1 }}
      >
        {carregando ? 'Tentando...' : 'Tentar de novo'}
      </button>
    </div>
  );
};

export default AvisoDadosDesatualizados;
